import { Dialog, Footer, TravelportLogo } from '@atlas-design-system/react'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import { RoutePath } from '../../../enums'

const year = new Date().getFullYear()
export const COPYRIGHT = `© ${year} Travelport`
export const AppFooter: React.FC = () => {
  const [showDialog, setShowDialog] = useState(true)

  const accurateVersionNumberPrefix =
    process.env.REACT_APP_VERSION?.slice(
      0,
      process.env.REACT_APP_VERSION.lastIndexOf('.') + 1 || 5,
    ) || '23.x.'
  const incrementedBuildVersionNumber: number =
    Number.parseInt(
      process.env.REACT_APP_VERSION?.slice(
        process.env.REACT_APP_VERSION.lastIndexOf('.') + 1,
      ) || '0',
    ) + 1

  return (
    <Footer
      data-testid="app-footer"
      copyright={COPYRIGHT}
      logo={<TravelportLogo />}
    >
      <Footer.Menu title="Links">
        <a
          href="https://www.travelport.com/privacy-websites"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </a>
        <Link to={`/${RoutePath.COOKIE_POLICY}`}>Cookie Policy</Link>
        <Link to={`/${RoutePath.COOKIE_POLICY_US}`}>Cookie Policy (US)</Link>
        <button
          style={{ cursor: 'pointer' }}
          onClick={() => {
            setShowDialog(false)
          }}
        >
          About
        </button>
      </Footer.Menu>
      <Dialog
        id="footer-about-dialog"
        title="About"
        hidden={showDialog}
        appearance="information"
        onDismiss={() => {
          setShowDialog(true)
        }}
      >
        <div>Merchandising Management Portal</div>
        <span>{`version: ${
          accurateVersionNumberPrefix + incrementedBuildVersionNumber
        }`}</span>
      </Dialog>
    </Footer>
  )
}
